// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/utils/provider/lang-provider.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/utils/provider/lang-provider.tsx");
  import.meta.hot.lastModified = "1724766136000";
}
// REMIX HMR END

import { useParams } from '@remix-run/react';
import { createContext, useContext, useMemo } from 'react';
import { langByParam } from '~/utils/lang';
import all from '../../locales';
export const LangContext = createContext({
  langDat: undefined,
  dict: undefined
});
export const LangProvider = ({
  children
}) => {
  _s();
  const {
    lang
  } = useParams();
  const langDat = langByParam(lang);
  const {
    lang_code
  } = langDat;
  const dict = useMemo(() => all[lang_code], [lang_code]);
  return <LangContext.Provider value={{
    langDat,
    dict
  }}>
            {children}
        </LangContext.Provider>;
};
_s(LangProvider, "gn0noYH04Pq25DxQY9JL2SXFRNY=", false, function () {
  return [useParams];
});
_c = LangProvider;
export const useLang = src => {
  _s2();
  const ctx = useContext(LangContext);
  const {
    dict
  } = ctx;
  const t = id => id && dict && dict[src] && dict[src][id] ? dict[src][id] : id;
  return t;
};
_s2(useLang, "/dMy7t63NXD4eYACoT93CePwGrg=");
var _c;
$RefreshReg$(_c, "LangProvider");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;